export default __webpack_public_path__ + "static/brilliantly-warm-345aa02b47e0d9e45722f68340234182.png";